var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"primary","icon":""},on:{"click":_vm.override}},[_c('v-icon',{attrs:{"x-small":"","title":"Automatic override to erase adjustment"}},[_vm._v("mdi-eraser")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }